import { render, staticRenderFns } from "./IDPProfile.vue?vue&type=template&id=5164c473"
import script from "./IDPProfile.vue?vue&type=script&lang=js"
export * from "./IDPProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports